import { render, staticRenderFns } from "./CertsTable.vue?vue&type=template&id=44c9f3cc&scoped=true"
import script from "./CertsTable.vue?vue&type=script&lang=js"
export * from "./CertsTable.vue?vue&type=script&lang=js"
import style0 from "./CertsTable.vue?vue&type=style&index=0&id=44c9f3cc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c9f3cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44c9f3cc')) {
      api.createRecord('44c9f3cc', component.options)
    } else {
      api.reload('44c9f3cc', component.options)
    }
    module.hot.accept("./CertsTable.vue?vue&type=template&id=44c9f3cc&scoped=true", function () {
      api.rerender('44c9f3cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/certificados/CertsTable.vue"
export default component.exports